import { createSlice } from '@reduxjs/toolkit';
import { addTemplate, findElementById } from './TemplateJsonSlice';
import templateJsonStore from './TemplateJsonStore';

const initialState = {
  id: null,
  item: null
};

const templateSelectedItemSlice = createSlice({
  name: 'templateSelectedItem',
  initialState,
  reducers: {
    selectItem: (state, action) => {
      state.id = action.payload
      if (state.id) {
        state.item = findElementById(templateJsonStore.getState().templateJson, state.id);
      } else {
        // ↓はnulにしているが、何も選択されていないときはappを選択にする
        //state.item = null;

        //↑を変更2023/09/27
        state.item = templateJsonStore.getState().templateJson.templates[0];
        state.id = state.item.id;
      }
    },
    reSelectItem: (state) => {
      if (state.id) {
        state.item = findElementById(templateJsonStore.getState().templateJson, state.id);
      }
    },
    deselectItem: state => {
      // if (state.id === null) return;
      // state.id = null;
      // state.item = null;
      const appId = templateJsonStore.getState().templateJson.templates[0].id

      if (state.id === appId) return;
      state.id = appId;
      state.item = templateJsonStore.getState().templateJson.templates[0];
    },
  }
});

export const { selectItem, deselectItem, reSelectItem } = templateSelectedItemSlice.actions;
export default templateSelectedItemSlice.reducer;
